import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';
import AsyncSelect, { Props as AsyncPaginateProps } from 'react-select-async-paginate';
import { OptionsElement } from './../../../../Models/ViewManagementModel';
import {Loader} from "components/Map/MapHelpers/MapSearch.Manager";

export interface IAdditionalLoadOptions {
  first: number
  search: string
}

interface IFetchedData<Additional extends IAdditionalLoadOptions = IAdditionalLoadOptions>  {
  options: OptionsElement[]
  additional?: Additional
}

type LoadOptionsParameters<Additional extends IAdditionalLoadOptions = IAdditionalLoadOptions> = Parameters<
  AsyncPaginateProps<OptionsElement, Additional>['loadOptions']
>
export type FetchOptions = <Additional extends IAdditionalLoadOptions = IAdditionalLoadOptions>(
  search: LoadOptionsParameters<Additional>[0],
  additional: LoadOptionsParameters<Additional>[2],
) => Promise<IFetchedData<Additional>>

type Props<Additional extends IAdditionalLoadOptions = IAdditionalLoadOptions> = {
  label: string;
  type: string;
  max?: number;
  min?: number;
  disabled: boolean;
  options: Array<OptionsElement>;
  wrapperClassName?: string;
  e2eId?: string
  fetchOptions: FetchOptions
} & Omit<AsyncPaginateProps<OptionsElement, Additional>, 'loadOptions'>;

const MAX_USERS_TO_FETCH = 25

const LoaderSpinner = () => (<div style={{ display: 'flex', marginRight: '8px' }}><Loader /></div>)

class AutoCompleteField<Additional extends IAdditionalLoadOptions = IAdditionalLoadOptions> extends React.PureComponent<WrappedFieldProps & Props<Additional>> {
  private loadOptions = async (
    search: LoadOptionsParameters<Additional>[0],
    previousOptions: LoadOptionsParameters<Additional>[1],
    additionalOptions: LoadOptionsParameters<Additional>[2]
  ) => {
    if (!this.props.fetchOptions) {
      return undefined
    }
    const { options } = await this.props.fetchOptions(search, additionalOptions);
//@ts-ignore
    const newOptions =  [...previousOptions, ...options]
    const hasMore = options.length === MAX_USERS_TO_FETCH

    return {
      //@ts-ignore
      options: additionalOptions.first === 0 ? newOptions : options,
      hasMore,
      additional: {
        // @ts-ignore
        first: search === additionalOptions.search ? newOptions.length : 0,
        search
      }
    }
  }

  public render() {
    const {input, meta, label, disabled, wrapperClassName} = this.props;
    let formClasses: string = 'form-field ';
    formClasses += meta.error && meta.touched ? ' form-field--error' : '';
    formClasses += wrapperClassName ? ` ${wrapperClassName} ` : '';
    formClasses += disabled ? ' form-field--disabled' : '';

    return (
      <div className={formClasses}>
        <label className="form-field__label" htmlFor={input.name}>{label}</label>
        <div date-e2eid={(this.props.e2eId) ? this.props.e2eId : null}>
          <AsyncSelect
            defaultOptions
            id={input.name}
            styles={
              {
                control: (styles) => ({
                  ...styles,
                  padding: '4px 2px'
                }),
                option: () => ({}),
              }
            }
            classNamePrefix={'form-control'}
            value={input.value}
            onChange={input.onChange}
            onBlur={() => {
              input.onBlur(input.value);
            }}
            className="form-control"
            isDisabled={disabled}
            {...this.props}
            loadOptions={this.loadOptions}
            additional={{
              first: 0,
              search: '',
              ...(this.props.additional ?? {})
            }}

            components={{
              LoadingIndicator: LoaderSpinner,
              ...(this.props.components ?? {})
            }}
          />
          {(meta.touched &&
              (meta.error && (
                <div className="form-field__error"
                     date-e2eid={(this.props.e2eId) ? this.props.e2eId + "_error" : null}>
                  {meta.error}
                </div>
              ))) ||
            (meta.warning && <span>{meta.warning}</span>)}
        </div>
      </div>
    );
  }
}

export default AutoCompleteField;



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/AutoCompleteField.tsx